/**
 * Change document title dynamically
 *
 * @export
 * @param {*} section
 * @param {boolean} [isHomePage=false]
 * @returns
 */
export default function useChangeDocumentTitle(section = ``) {
  const newDocumentTitle = `Canal Digital - ${section}`
  if (document.title !== newDocumentTitle) {
    document.title = newDocumentTitle
  }
}
